"use client";

import Image from "next/image";
import Link from "next/link";
import { ErrorBoundary } from "@/components/error-boundary";
import { useExploreRoute } from "../_lib/explore-route-context";
import { MobileFooterNewsletter } from "./mobile-footer-newsletter";

const TELEGRAM_HREF = "https://t.me/aiprimer";
const X_HREF = "https://x.com/aidailyprimer";

export function ExploreFooter() {
  const { reportType } = useExploreRoute();
  const showX = reportType === "engineer";

  return (
    <footer
      className="mt-12 border-[var(--explore-border-light)] border-t bg-[var(--explore-bg-card)]"
      style={{ fontFamily: "var(--homepage-sans-stack)" }}
    >
      <div className="mx-auto flex max-w-[1320px] flex-col items-center gap-6 px-6 pt-10 pb-4">
        {/* Brand */}
        <div className="flex items-center gap-2">
          <Image
            alt="AI Primer"
            className="rounded-[9px]"
            height={32}
            src="/logo.webp"
            width={32}
          />
          <span className="font-bold text-[1rem] text-[var(--explore-text-primary)]">
            AI Primer
          </span>
        </div>

        <p className="max-w-[420px] text-center text-[0.85rem] text-[var(--explore-text-muted)] leading-relaxed">
          Your daily guide to AI tools, workflows, and creative inspiration.
        </p>

        {/* Social icons */}
        <div className="flex gap-3">
          {/* Telegram */}
          <Link
            aria-label="Telegram"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--explore-bg)] text-[var(--explore-text-muted)] transition-all hover:bg-[var(--explore-accent-yellow)] hover:text-[var(--explore-on-accent-text)]"
            data-ph-capture-attribute-edition={reportType}
            data-ph-capture-attribute-link-type="social"
            data-ph-capture-attribute-social-network="telegram"
            href={TELEGRAM_HREF}
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg fill="currentColor" height="18" viewBox="0 0 24 24" width="18">
              <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
            </svg>
          </Link>

          {/* X / Twitter — engineer only */}
          {showX && (
            <Link
              aria-label="X"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--explore-bg)] text-[var(--explore-text-muted)] transition-all hover:bg-[var(--explore-accent-yellow)] hover:text-[var(--explore-on-accent-text)]"
              data-ph-capture-attribute-edition={reportType}
              data-ph-capture-attribute-link-type="social"
              data-ph-capture-attribute-social-network="x"
              href={X_HREF}
              rel="noopener noreferrer"
              target="_blank"
            >
              <svg
                fill="currentColor"
                height="18"
                viewBox="0 0 24 24"
                width="18"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </Link>
          )}
        </div>

        {/* Mobile newsletter — hidden on desktop where sidebar handles it */}
        <ErrorBoundary source="mobile_footer_newsletter_boundary">
          <MobileFooterNewsletter />
        </ErrorBoundary>
      </div>

      {/* Bottom bar */}
      <div className="mx-auto flex max-w-[1320px] items-center justify-center border-[var(--explore-border-light)] border-t px-6 pt-5 pb-[calc(1.25rem+env(safe-area-inset-bottom,0px))] text-[0.8rem] text-[var(--explore-text-muted)]">
        <span>&copy; 2026 AI Primer. All rights reserved.</span>
      </div>
    </footer>
  );
}
